import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePopup } from '../../contexts/PopupContext';
import LanguageSwitcher from '../layout/LanguageSwitcher';
import {
  SettingsAccountIcon,
  SettingsPrivacyIcon,
  SettingsNotificationIcon,
  SettingsBillingIcon,
  SettingsAppearanceIcon,
  SettingsAboutIcon,
  SettingsHelpIcon,
  SettingsLogoutIcon,
} from '../profile/settings/SettingsMenuIcons';
import './SettingsPopup.css';

function SettingsPopup({ onLogout }) {
  const { t } = useTranslation(['profile', 'shared']);
  const { openPopup, closeAllPopups } = usePopup();
  const menuItems = [
    {
      id: 'account',
      icon: SettingsAccountIcon,
      colorClass: 'settings-menu-icon-wrap--account',
      label: t('profile.settings.menu.account'),
    },
    {
      id: 'privacy',
      icon: SettingsPrivacyIcon,
      colorClass: 'settings-menu-icon-wrap--privacy',
      label: t('profile.settings.menu.privacy'),
    },
    {
      id: 'notifications',
      icon: SettingsNotificationIcon,
      colorClass: 'settings-menu-icon-wrap--notifications',
      label: t('profile.settings.menu.notifications'),
    },
    {
      id: 'billing',
      icon: SettingsBillingIcon,
      colorClass: 'settings-menu-icon-wrap--billing',
      label: t('profile.settings.menu.billing'),
    },
    {
      id: 'appearance',
      icon: SettingsAppearanceIcon,
      colorClass: 'settings-menu-icon-wrap--appearance',
      label: t('profile.settings.menu.appearance', 'Wygląd'),
    },
    {
      id: 'about',
      icon: SettingsAboutIcon,
      colorClass: 'settings-menu-icon-wrap--about',
      label: t('profile.settings.menu.about'),
    },
    {
      id: 'help',
      icon: SettingsHelpIcon,
      colorClass: 'settings-menu-icon-wrap--help',
      label: t('profile.settings.menu.help'),
    },
  ];

  const handleMenuItemClick = (itemId) => {
    const popupTypeMap = {
      account: 'settings-account',
      privacy: 'settings-privacy',
      notifications: 'settings-notifications',
      billing: 'settings-billing',
      appearance: 'settings-appearance',
      about: 'settings-about',
      help: 'settings-help',
    };

    const popupType = popupTypeMap[itemId];
    if (popupType) {
      openPopup(popupType, {}, 1);
    }
  };

  const handleLogoutClick = () => {
    closeAllPopups();
    onLogout?.();
  };

  return (
    <div className="settings-popup-content">
      <div className="settings-container">
        <div className="settings-menu">
          <div className="settings-menu-section">
            {menuItems.map((item) => {
              const Icon = item.icon;
              return (
                <button
                  key={item.id}
                  type="button"
                  className="settings-menu-item"
                  onClick={() => handleMenuItemClick(item.id)}
                >
                  <span className={`settings-menu-icon-wrap ${item.colorClass}`}>
                    <Icon />
                  </span>
                  <span className="settings-menu-label">{item.label}</span>
                  <span className="settings-menu-arrow" aria-hidden>
                    <svg
                      className="settings-menu-arrow-svg"
                      viewBox="0 0 24 24"
                      width="18"
                      height="18"
                      fill="none"
                      focusable="false"
                    >
                      <path
                        d="M9 6.75 14.25 12 9 17.25"
                        stroke="currentColor"
                        strokeWidth="1.75"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </button>
              );
            })}
          </div>

          <div className="settings-menu-section settings-menu-section--language">
            <div className="settings-menu-language-head">
              <span className="settings-menu-language-title">{t('shared:language.switch')}</span>
            </div>
            <div className="settings-menu-language-body">
              <LanguageSwitcher />
            </div>
          </div>

          {onLogout && (
            <>
              <div className="settings-menu-divider" />
              <div className="settings-menu-section">
                <button
                  type="button"
                  className="settings-menu-item settings-menu-item-logout"
                  onClick={handleLogoutClick}
                >
                  <span className="settings-menu-icon-wrap settings-menu-icon-wrap--logout">
                    <SettingsLogoutIcon />
                  </span>
                  <span className="settings-menu-label">{t('profile.logout')}</span>
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default SettingsPopup;
